module.exports = __webpack_public_path__ + "3f3bb6fdf0ccdfccc7e2f17b06864a3d.png";